
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remote-modal"
export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:submit-end', (event) => {
      if (event.detail.fetchResponse.response.status == 201 ){
        this.close()
      }
    })
  }

  close() {
    document.getElementById('modal-container').classList.add('animate', 'animate__bounceOut')
    setTimeout(() => {
      this.element.remove()
    }, 600)
  }

  closeOnBackdrop(event) {
    // Only close if click is on the backdrop (outside the modal-container)
    const modalContainer = document.getElementById('modal-container')
    if (!modalContainer.contains(event.target)) {
      this.close()
    }
  }}